import { useUserCheckLoggedIn } from '@/data/User';
import { CompleteDataDialogContent } from '@/components/blocks/CompleteDataDialog/CompleteDataDialogContent';

export const CompleteDataDialog = () => {
	const { isLoggedIn } = useUserCheckLoggedIn();

	if (!isLoggedIn) return null;

	return <CompleteDataDialogContent />;
};
